<template id="">
    <div class="logo">
        <router-link :class="anchorClass" :to="anchorLink">
            <img :src="inverseLogo" class="inverse" />
            <img :src="mainLogo" class="main" />
        </router-link>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        anchorClass: {
            type: String,
            default: '',
        },
        anchorLink: {
            type: String,
            default: '/insights',
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            mainLogo: '',
            inverseLogo: '',
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['displaySettings']),
    }, // End of Component > mounted
    watch: {
        displaySettings(value) {
            if (value) {
                this.getDisplaySettingConf()
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getDisplaySettingConf()
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        getDisplaySettingConf() {
            if (this.displaySettings) {
                document
                    .querySelector(':root')
                    .style.setProperty(
                        '--primary-color',
                        this.displaySettings.colors.primary
                    )
                document
                    .querySelector(':root')
                    .style.setProperty(
                        '--secondary-color',
                        this.displaySettings.colors.secondary
                    )
                document
                    .querySelector(':root')
                    .style.setProperty(
                        '--interface-medium-color',
                        this.displaySettings.colors.light
                    )
                document
                    .querySelector(':root')
                    .style.setProperty(
                        '--interface-dark-color',
                        this.displaySettings.colors.dark
                    )
            }
            this.mainLogo = this.displaySettings
                ? `${process.env.VUE_APP_API_URL}files/logo/${this.displaySettings.logo.dark.fileName}`
                : ''
            this.inverseLogo = this.displaySettings
                ? `${process.env.VUE_APP_API_URL}files/logo/${this.displaySettings.logo.light.fileName}`
                : ''
        },
    },
} // End of export default
</script>
